export interface AppConfig {
  apiSandboxUrl: string;
  apiProductionUrl: string;
  docsBaseUrl: string;
  docsBaseUrlGo: string;
  hostedSolutionsUrl: string;
  environment: 'development' | 'staging' | 'production';
  auth: {
    clientId: string;
    authority: string;
    knownAuthority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    scopes: string[];
  };
  features: {
    secretLimit: number
    applicationLimit: number;
  },
}

const config: AppConfig = {
  // Sandbox and Production API URLs (controlled by env files)
  apiSandboxUrl: process.env.REACT_APP_API_SANDBOX_URL,
  apiProductionUrl: process.env.REACT_APP_API_PROD_URL,
  docsBaseUrl: process.env.README_BASE_URL,
  docsBaseUrlGo: process.env.README_BASE_URL_GO,
  docsLegacyUrl: process.env.LEGACY_URL,
  hostedSolutionsUrl: process.env.HOSTED_SOLUTIONS_URL || '',
  environment: (process.env.NODE_ENV as any) || 'development',
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTHORITY || '',
    knownAuthority: process.env.REACT_APP_KNOWN_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.origin,
    // Handle both space-separated AND comma-separated scopes from .env
    scopes: (process.env.REACT_APP_API_SCOPES || 'openid profile email')
      .split(/[\s,]+/) // Split by spaces OR commas
      .map(s => s.trim()) // Trim whitespace
      .filter(s => s.length > 0), // Remove empty strings
  },
  features: {
    secretLimit: 2,
    applicationLimit: 2,
  },
};

export default config;
